import { Box } from "@mui/material";
import moment from "moment";
import ActionBar from "../../../components/Actionbar/ActionBars";
import Header from "../../../components/Header/Header";
import DashboardTable from "../../../components/Table/DashboardTable";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import "../../../components/dataTable.scss";
import * as pre from "../../../redux/pre_processor/actions";
import {
  clearApiStatus,
  clearAutoRefresh,
  uploadedTagClear,
} from "../../../redux/pre_processor/actions";
import constant from "../../../constants/constantValues";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import PendingFiles from "../../../components/PendingFiles";
import { getPendingBatchesList } from "../../../redux/shared/actions";
import Label from "../../../components/Label/Label";
// import UploadedFilesList from "../../../components/UploadedFilesList";

const ProcessorDashboard = () => {
  const dispatch = useDispatch();
  const [projects, setProjects] = useState([]);
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [list, setList] = useState([]);

  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const ocrReinitiateStatus = useSelector(
    (state) => state?.prePro?.ocrReinitiateStatus
  );
  const autoRefresh = useSelector((state) => state?.prePro?.autoRefresh);

  const [openFileStatusDialog, setOpenFileStatusDialog] = useState(false);

  const pendinBatchesList = useSelector(
    (state) => state?.shared?.pendinBatchesList
  );

  const {
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    PDFS,
    ASSIGNED,
    OCR_STATUS,
    LAST_UPDATED,
    ACTION,
  } = constant;
  const projectFromState = useSelector(
    (state) => state?.prePro?.preProProjects
  );

  const type = useSelector((state) => state?.prePro?.type);

  useEffect(() => {
    setProjects(projectFromState.data);
  }, [type]);

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(uploadedTagClear());
    dispatch(clearAutoRefresh());
    const autoRefresh = false;
    //Get Pre Processor Projects and Batches.
    dispatch(
      pre.getPreProProjects({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
        autoRefresh,
      })
    );
    dispatch(getPendingBatchesList({}));
  }, [dispatch]);

  useEffect(() => {
    if (apiStatus?.apiError) {
      setMessage(apiStatus.message);
      setSeverity("error");
      setNotification(true);
      dispatch(clearApiStatus());
    }
  }, [apiStatus]);

  useEffect(() => {
    if (ocrReinitiateStatus?.apiError) {
      setMessage(ocrReinitiateStatus.message);
      setSeverity("error");
      setNotification(true);
      dispatch(clearApiStatus());
    }
    if (
      ocrReinitiateStatus?.message !== null &&
      ocrReinitiateStatus?.apiSuccess === true
    ) {
      setNotification(true);
      setMessage(ocrReinitiateStatus?.message);
      setSeverity("success");
      dispatch(pre.clearOcrReinitiateApiStatus());
      dispatch(
        pre.getPreProProjects({
          type: "",
          formattedStartDate: "",
          formattedEndDate: "",
          status: "",
          autoRefresh: false,
        })
      );
      // setLoader(false);
    }
  }, [ocrReinitiateStatus]);

  useEffect(() => {
    if (autoRefresh?.isAutoRefresh && autoRefresh?.isAutoRefresh) {
      const autoRefresh = true;
      dispatch(
        pre.getPreProProjects({
          type: "",
          formattedStartDate: "",
          formattedEndDate: "",
          status: "",
          autoRefresh,
        })
      );
      dispatch(clearAutoRefresh());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh]);

  useEffect(() => {
    // if (projectFromState.data?.length > 0) {
    setProjects(projectFromState?.data);
    // }
  }, [projectFromState?.data]);

  useEffect(() => {
    const baseURL = process.env.REACT_APP_APIBASE_WS;
    const newSocket = new WebSocket(
      `${baseURL}/auto-extraction-status/?token_header=${localStorage.getItem(
        "token"
      )}`
    );

    newSocket.onopen = () => {};

    newSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const completionID = data?.payload?.Batch_Id;
      if (completionID >= 0) {
        setProjects((prevProjects) =>
          prevProjects?.map((project) => {
            const indexToUpdate = project?.batch_info?.findIndex(
              (item) => item.batch_id === completionID
            );
            if (indexToUpdate !== -1) {
              const updatedProject = { ...project };
              updatedProject.batch_info = [...project.batch_info];
              updatedProject.batch_info[indexToUpdate] = {
                ...project.batch_info[indexToUpdate],
                completion_status: data?.payload?.Completion,
                is_ocr_done: data?.payload?.is_ocr_done,
                ocr_re_initiate: data?.payload?.ocr_re_initiate,
                is_failed: data?.payload?.is_failed,
              };
              return updatedProject;
            }
            return project;
          })
        );
      }
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket error: ", error);
    };

    return () => {
      newSocket.close();
    };
  }, []);

  useEffect(() => {
    if (pendinBatchesList?.data?.preprocessor_projects?.length > 0) {
      setList(pendinBatchesList?.data?.preprocessor_projects);
    }
  }, [pendinBatchesList?.data?.preprocessor_projects]);

  const onSearch = (word, type) => {
    let result;
    let filteredProjects = [];

    if (!projectFromState?.data || !Array.isArray(projectFromState.data)) {
      setProjects([]);
      return;
    }

    if (type === "project") {
      if (word) {
        result = projectFromState?.data.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
      } else {
        result = projectFromState.data;
      }
    } else {
      if (word) {
        projectFromState?.data?.map((item, index) => {
          const filteredBatches = item?.batch_info?.filter(function (el) {
            return (
              el?.batch_name
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) !== -1
            );
          });
          if (filteredBatches?.length > 0) {
            filteredProjects.push({
              ...projectFromState?.data[index],
              batch_info: filteredBatches,
            });
          } else {
          }
        });
        result = filteredProjects;
      } else {
        result = projectFromState?.data;
      }
    }
    setProjects([...result]);
  };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";

    dispatch(
      pre.getPreProProjects({
        type,
        formattedStartDate,
        formattedEndDate,
        status,
      })
    );
  };
  const clear = () => {
    dispatch(clearApiStatus());

    dispatch(
      pre.getPreProProjects({
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
  };

  let header = [
    PROJECT_NAME,
    BATCH_NAME,
    COUNT,
    PDFS,
    ASSIGNED,
    OCR_STATUS,
    LAST_UPDATED,
    ACTION,
  ];

  const onClickViewPendingBatches = () => {
    setOpenFileStatusDialog(true);
  };

  return (
    <>
      <Header />
      <ActionBar
        onSearch={(value, type) => onSearch(value, type)}
        filterByDate={filterByDate}
        clear={clear}
        onClickViewPendingBatches={onClickViewPendingBatches}
        list={list}
      />
      {/* <ProjectHeader text={PROJECT_HEADER} headerColor="white" /> */}
      {projectFromState.loader ? (
        <DashboardTableSkaleton />
      ) : projects?.length === 0 ? (
        <div className="no-data">
          <Label
            text="No Data Found"
            fontSize="16"
            fontWeight="600"
            padding="20px"
          />
        </div>
      ) : (
        <DashboardTable header={header} projects={projects} />
      )}
      {notification && (
        <CustomizedSnackbars
          severity={severity}
          state={notification}
          text={message}
          handleClose={() => setNotification(false)}
        />
      )}

      <PendingFiles
        openFileStatusDialog={openFileStatusDialog}
        setOpenFileStatusDialog={setOpenFileStatusDialog}
        list={list}
      />
    </>
  );
};
export default ProcessorDashboard;
